import { useEffect, useRef, useState } from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import styles from './AdminMenu.module.css';
import { useNavigate, Outlet } from 'react-router-dom';
import Grow from '@material-ui/core/Grow';
import getHeaderData from 'config/HeaderData';
import { Divider, Paper, Tab, Tabs, Tooltip, Box, useMediaQuery } from '@material-ui/core';
import { useSelector } from 'react-redux';
import MetricsViewer from './MetricsViewer/MetricsViewer';
import { useTranslation } from 'react-i18next';
const AdminMenu = ({ match }) => {
  const navigate = useNavigate();
  const uploadLoading = useSelector((state) => state.nonPersistedReducers.uploadSliceReducer.loading);
  const { t } = useTranslation();
  const HeaderData = getHeaderData(t);

  const shopId = useSelector((state) => state.nonPersistedReducers?.shopSliceReducer?.shopId);

  const user = useSelector((state) => state.nonPersistedReducers?.userSliceReducer?.currentUser);
  const tabsActions = useRef();

  const desktop = useMediaQuery('(min-width: 992px)');

  const [permissions, setPermissions] = useState({
    ownedShop: false,
    managePricing: false,
    viewPricing: false,
    viewProducts: false,
    viewShops: false,
    viewInvoiceVendors: false
  });

  useEffect(() => {
    setTimeout(() => {
      if (tabsActions?.current) {
        tabsActions.current.updateIndicator();
      }
    }, 1000);
  }, [tabsActions]);

  useEffect(() => {
    if (user !== null && shopId !== null)
      if (user?.ownedShops[0]?.id === shopId) {
        setPermissions({
          ownedShop: true,
          managePricing: false,
          viewPricing: false,
          viewProducts: false,
          viewShops: false,
          viewInvoiceVendors: false
        });
      } else {
        setPermissions({
          ownedShop: false,
          managePricing: user?.maintainedShops
            ?.find((shop) => shop.shop.id === shopId)
            ?.scopes?.includes('MANAGE_PRICING'),
          viewPricing: user?.maintainedShops?.find((shop) => shop.shop.id === shopId)?.scopes?.includes('VIEW_PRICING'),
          viewProducts: user?.maintainedShops
            ?.find((shop) => shop.shop.id === shopId)
            ?.scopes?.includes('VIEW_PRODUCTS'),
          viewShops: user?.maintainedShops?.find((shop) => shop.shop.id === shopId)?.scopes?.includes('VIEW_SHOP'),
          viewInvoiceVendors: user?.maintainedShops
            ?.find((shop) => shop.shop.id === shopId)
            ?.scopes?.includes('VIEW_INVOICE_VENDORS')
        });
      }
  }, [user, shopId]);

  const renderTab = ({ option, idx, isDisabled = false, tooltip = '', height = '36px', isDivider = false }) => {
    const tab = (
      <Tab
        key={`${idx}_option_tab`}
        selected={window.location.pathname.includes(option.to)}
        value={option.to}
        disabled={isDisabled || uploadLoading}
        style={{
          minWidth: '50px',
          minHeight: height,
          height: height,
          fontFamily: 'var(--font-main) !important'
        }}
        onClick={() => !isDisabled && navigate(option.to)}
        label={option.name}
      />
    );
    return tooltip !== '' ? (
      <Tooltip title={tooltip} key={`${idx}_option_tab`}>
        <span className={styles.spanContainer}>{tab}</span>
      </Tooltip>
    ) : isDivider ? (
      [<Divider key={`${idx}_divider`} />, tab]
    ) : (
      tab
    );
  };

  return (
    <div className={styles.root}>
      <CssBaseline />
      <Grow in={true} timeout={1000}>
        <Paper className={styles.settingsContainer}>
          <Tabs
            TabIndicatorProps={{
              style: { background: 'var(--primary-main)' }
            }}
            action={tabsActions}
            orientation='vertical'
            variant='fullWidth'
            value={
              HeaderData.options.admin.find((option) => window.location.pathname.toString().includes(option.to))?.to ||
              `${match?.url}/orders`
            }
            className={styles.tabs}>
            {HeaderData.options.admin.map((option, idx) => {
              switch (option.to) {
                case 'templates':
                  return renderTab({ option: option, idx: idx, height: '65px' });
                case 'subscriptions':
                  if (permissions.ownedShop) {
                    return renderTab({ option: option, idx: idx, height: '65px', isDivider: true });
                  } else {
                    return null;
                  }
                case 'galleries':
                  if (!permissions.ownedShop && !permissions.viewProducts) {
                    return renderTab({
                      option: option,
                      idx: idx,
                      isDisabled: true,
                      tooltip: t('adminMenu.onlyWithViewPermission')
                    });
                  } else {
                    return renderTab({ option: option, idx: idx });
                  }
                case 'roles':
                  if (!permissions.ownedShop && !permissions.viewShops) {
                    return renderTab({
                      option: option,
                      idx: idx,
                      isDisabled: true,
                      tooltip: t('adminMenu.onlyWithViewPermission')
                    });
                  } else {
                    return renderTab({ option: option, idx: idx });
                  }
                case 'invoicing':
                  if (!permissions.ownedShop && !permissions.viewInvoiceVendors) {
                    return renderTab({
                      option: option,
                      idx: idx,
                      isDisabled: true,
                      tooltip: t('adminMenu.onlyWithInvoiceViewPermission')
                    });
                  } else {
                    return renderTab({ option: option, idx: idx });
                  }
                default:
                  return renderTab({ option: option, idx: idx });
              }
            })}
            {/*
           NEEDED IN PHOTOGRAPHER PROFILE VERSION
           <Divider />
            <Tab
              selected={window.location.pathname?.includes('/photographer-profile')}
              value={'photographer-profile'}
              disabled={uploadLoading}
              style={{
                minWidth: '50px',
                minHeight: '36px',
                height: '36px',
                margin: '0.5rem 0'
              }}
              onClick={() => navigate(`photographer-profile`)}
              label={`Fotós profil`}
              key={`photographer-profile_option_tab`}
            />*/}
            <Divider />
            <MetricsViewer isOwnShop={permissions.ownedShop} shopId={shopId} />
          </Tabs>
          <Box
            sx={{
              width: desktop ? (window.location.pathname.includes('/administration/orders') ? '88%' : '100%') : '100%'
            }}>
            <Outlet />
          </Box>
        </Paper>
      </Grow>
    </div>
  );
};

export default AdminMenu;
